import SEO from "components/seo";
import CareerList from "containers/careerList/careerList";
import useLocale from "hooks/useLocale";
import { useInfiniteQuery } from "react-query";
import careerService from "services/career";
import Loader from "components/loader/loader";
import LoadMore from "components/button/load-more";

type Props = {};

export default function Careers({}: Props) {
  const { t, locale } = useLocale();

  const { data, fetchNextPage, hasNextPage, isFetchingNextPage, isLoading } =
    useInfiniteQuery(
      ["careers", locale],
      ({ pageParam = 1 }) =>
        careerService.getAll({ page: pageParam, active: 1 }),
      {
        getNextPageParam: (lastPage: any) => {
          if (lastPage.meta.current_page < lastPage.meta.last_page) {
            return lastPage.meta.current_page + 1;
          }
          return undefined;
        },
      },
    );

  return (
    <>
      <SEO title={t("careers")} />
      <div className="bg-white container" style={{ minHeight: "60vh" }}>
        <CareerList
          data={data?.pages?.flatMap((item) => item.data) || []}
          loading={isLoading && !isFetchingNextPage}
        />
        {isFetchingNextPage && <Loader />}
        {hasNextPage && (
          <div style={{ marginTop: "30px" }}>
            <LoadMore size="small" onClick={fetchNextPage}>
              {t("load.more")}
            </LoadMore>
          </div>
        )}
      </div>
    </>
  );
}
